import { useEffect, useState } from 'react';
import { PickerFormItem, PickerSourceListType } from './PickerFormTypes';
import FilterSearchBox from '../FilterPanel/FilterSearchBox/FilterSearchBox';
import Button from '../../../common/Button/Button';
import { Label } from '../../../common/Label/Label';
import { FORM_PICKER_LABELS } from '../../../../lib/constants/labelKeys';
import styles from './PickerForm.module.scss';
import { pickerFormIds } from '../../../../lib/tests/testIds';

export function PickerSourceList<T extends PickerFormItem>({
  titleKey,
  list,
  render,
  filterFunction,
  isSelectedFn,
  onSelect,
  onDeselect,
  idFunction,
  searchPlaceholderKey,
}: PickerSourceListType<T>) {
  const [searchValue, setSearchValue] = useState('');
  const [filteredItems, setFilteredItems] = useState(list);

  useEffect(() => {
    setFilteredItems(list.filter(filterFunction(searchValue)));
  }, [list, searchValue]);

  return (
    <div className={styles.tabContainer} data-testid={pickerFormIds.sourceItemList}>
      <div className={styles.searchboxContainer}>
        <FilterSearchBox customPlaceholderKey={searchPlaceholderKey} value={searchValue} onChange={setSearchValue} />
      </div>
      <ul id={`${titleKey}-tabpanel`} aria-labelledby={`${titleKey}-tab`} className={styles.tabpanel}>
        {filteredItems.map(li => (
          <li className={styles.listItem} key={idFunction(li)}>
            {render(li)}
            {isSelectedFn(li) ? (
              <Button variant="outlined" onClick={() => onDeselect(li)} className={styles.listButton}>
                <Label name={FORM_PICKER_LABELS.DESELECT_BUTTON} />
              </Button>
            ) : (
              <Button onClick={() => onSelect(li)} className={styles.listButton}>
                <Label name={FORM_PICKER_LABELS.SELECT_BUTTON} />
              </Button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
